import noCompaniesIcon from '../../../../../assets/no-companies-icon.svg';

import { Button } from '../../../../../common/_custom';

import styles from './EmptyDeals.module.scss';
import generating from '../../../../../assets/audited-financials-icon.svg';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { handleDealApplicationDrawer } from '../../../../../store/investor/action';
import { debtProductsEmpty } from '../../../../../assets/hostedassets';
import WhiteBackGroundPencilIcon from '../../../../../assets/Svg/WhiteBackGroundPencilIcon';
import { OFFERS_TEXT, OFFERS_CONFIG, CAPITAL_REQUIREMENT_BUTTON } from '../../../../Company/CompanyOffers/components/OffersConstants';
import { OffersReturn, useUploadData } from '../../../../Company/UploadData/useUploadData';
import { USER_TYPE } from '../../../../../utils/constants/user';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import AddToWatchlist, { ADD_JOURNEY } from '../../../Portfolio/components/AddToWatchlist/AddToWatchlist';
import { useState } from 'react';

const EmptyDeals = ({ handleClick, filterApplied, selectedCompany }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const [searchParams] = useSearchParams();

    // Get user data
    const userData = useAppSelector((state) => state.user.userData);
    const isCompanyUser = userData?.accountType === USER_TYPE.COMPANY;
    const isPartner = userData?.accountType === USER_TYPE.PARTNER;
    const investorOrgId = userData?.investorOrgId;

    // State for Add Lead modal
    const [showAddLeadModal, setShowAddLeadModal] = useState(false);

    const { openCapitalRequirementDrawer } = useUploadData({
        userType: USER_TYPE.COMPANY,
        mode: 'offers',
    }) as OffersReturn;

    const isCompanyDealsPage = location.pathname.includes('company-deals');
    const openDebtProducts = () => {
        // Get the company ID from params or selectedCompany
        const companyId = params.id || selectedCompany?.assesseeOrgId;

        // Create a new URLSearchParams with the same query parameters and set tab to debtProducts
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set('tab', 'debtProducts');

        // Navigate to the debt-products route
        navigate(`/investor/app/debt-products/${companyId}?${newSearchParams.toString()}`, {
            state: {
                ...location.state,
                mandateId: '',
            },
        });
    };

    const handleAddLeadSuccess = (data: { orgName: string; assesseeOrgId: string }) => {
        // Navigate to Leads page after successfully adding a lead
        navigate('/investor/app/scan');
    };

    if (isCompanyUser && !filterApplied) {
        return (
            <div
                className={styles.EmptyDeals}
                style={{
                    fontSize: '1.25rem',
                    color: '#535b62',
                    gap: '0.3rem',
                }}
            >
                <img src={debtProductsEmpty} alt="Empty" style={{ marginBottom: '1rem' }} />
                {OFFERS_TEXT.NO_LOANS}
            </div>
        );
    }

    return filterApplied ? (
        <div className={styles.EmptyDeals}>
            <img src={generating} width="156.48px" height="123.05" alt="" />
            No Results Found
        </div>
    ) : isPartner && !filterApplied && !isCompanyDealsPage ? (
        <>
            <div className={styles.EmptyDeals}>
                <img src={noCompaniesIcon} alt="noComp" height="50px" />
                <div className={styles.Title}>Deals will appear here</div>
                <div className={styles.Subtext}>
                    Deals shared with lenders will appear here. Add quality leads to start sharing with lenders.
                </div>
                <Button text={'Add Lead'} variant={'primary'} onClick={() => setShowAddLeadModal(true)} />
            </div>
            {showAddLeadModal && (
                <AddToWatchlist
                    journey={ADD_JOURNEY.ADD_TO_SCAN}
                    modalOpen={showAddLeadModal}
                    closeModal={() => setShowAddLeadModal(false)}
                    investorOrgId={investorOrgId}
                    onSuccess={handleAddLeadSuccess}
                />
            )}
        </>
    ) : (
        <div className={styles.EmptyDeals}>
            <img src={noCompaniesIcon} alt="noComp" height="50px" />
            <div className={styles.Title}>Deals will appear here</div>
            {isCompanyDealsPage ? (
                <>
                    <div className={styles.Subtext}>Your deals will appear here once created. You can add or edit deal at any time.</div>
                    {!isPartner && <Button text={'Create Deal'} variant={'primary'} onClick={openDebtProducts} />}
                </>
            ) : (
                <>
                    <div className={styles.Subtext}>
                        Your deals will appear here once added. You can set up or edit your investment preferences at any time.
                    </div>
                    <Button text={'Investment Preferences'} variant={'primary'} onClick={handleClick} />
                </>
            )}
        </div>
    );
};

export default EmptyDeals;
